// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3Gj-g","container":"styles_container__20Y79","title":"styles_title__3jHjZ","wrapper":"styles_wrapper__dLLot","answer":"styles_answer__3DmJP"};